import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subject } from 'rxjs';
import { map, shareReplay, takeUntil } from 'rxjs/operators';
import { MatMenuModule } from '@angular/material/menu';

import { DataService } from 'src/app/expense/receipt/data.service';
import { UserStateService } from 'src/app/expense/receipt/detail/userState.service';
import { NavigationEnd, Router } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { HeadlineService } from 'src/app/common/services/headline.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css'],
})
export class ToolbarComponent implements OnInit {
  @ViewChild('drawer') sidenav!: MatSidenav;
  isExpanded = true;
  notificationPanelOpen: boolean = false;
    showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  name = '';
  toolbarHeadline=''
  userRoles: any[] = [];
  roleEmp:any[]=[];
  isSubListVisible = false;
  roles: { role: string }[] = [];
  isSideNavOpened = false;
  isHandset$: Observable<boolean>;
  menuButton:boolean=false
  @ViewChild('drawer') drawer: MatSidenav | undefined;
  private destroyed$ = new Subject<void>();
  constructor(
    private ds: DataService,
    private headlineService: HeadlineService,
    private userStateService: UserStateService,
    private breakpointObserver: BreakpointObserver,
    private router:Router,
  ) {
    const loginResponse = localStorage.getItem('userNameLogin');
    if (loginResponse !== null) {
      this.name = loginResponse;
    }
    this.isHandset$ = this.breakpointObserver
      .observe(Breakpoints.Handset)
      .pipe(
        map((result) => result.matches),
        shareReplay()
      );
  }
  
  ngOnInit(): void {
    this.headlineService.headline.subscribe(headline => {
      this.toolbarHeadline = headline;
    });
    this.name = localStorage.getItem('userNameLogin') || '';
    this.getUserRole();
    this.userStateService.rolesSubject.pipe(map(roles=>{
      return roles.map(x=>{return {role:x}})
    })).subscribe((roles) => {
      if(roles){
        this.roles = roles;
        // Log roles for debugging
        console.debug('Roles updated in ToolbarComponent:', roles);
      }
    });
    this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const isUserLoginRoute = this.router.isActive('/login', true);
        const isUserAssignRoute = this.router.isActive('/userassign', true);
        const isUserOrgRoute = this.router.isActive('/organization', true);
        const isUserJoinRoute = this.router.isActive('/register', true);
        const isUserScanRoute = this.router.isActive('/scaned-receipts', true);
        const isUserLogOutRoute = this.router.isActive('/logout', true);
        const isAboutRoute = this.router.isActive('/about', true);
        if ((isUserLoginRoute || isUserAssignRoute || isUserOrgRoute ||  isUserJoinRoute || isUserScanRoute || isUserLogOutRoute || isAboutRoute) && this.drawer) {
          this.drawer.close();
        }
      }
    });
  }
  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  toggleNotificationPanel() {
    // Toggle the visibility of the notification panel
    this.notificationPanelOpen = !this.notificationPanelOpen;
  }
  
toggleSubList(): void {
  this.isSubListVisible = !this.isSubListVisible;
}
  closeSidenav(): void {
    if (this.drawer) {
      this.drawer.close();
      this.isSideNavOpened=false;
      // this.toggleSubList();
    }
  }
  isLoggedIn(): boolean {
    return !!localStorage.getItem('currentUser');
  }
  toggleSideNav() {
    this.isSideNavOpened = !this.isSideNavOpened;
    this.menuButton = !this.isSideNavOpened;
  }
  getUserIdFromLocal(): string {
    const storedResponse = localStorage.getItem('LoginResponse');
    if (storedResponse !== null) {
      const parsedResponse = JSON.parse(storedResponse);
      return parsedResponse._items[0].user_id;
    } else {
      console.error('Stored response is null');
      return '';
    }
  }
  isOrganizationLinkVisible(): boolean {
    return this.isLoggedIn() && (this.hasRole('OrganizationAdmin') || this.hasRole('SuperAdmin') || this.hasNoRole() || this.hasEmpRole('Employee'));
  }
  
  hasNoRole(): boolean {
    return this.isLoggedIn() && this.roles.length === 0;
  }

  isScannedReceiptsLinkVisible(): boolean {
    return (
      this.isLoggedIn() &&
      (
        this.hasRole('Manager') ||
        this.hasRole('Employee') ||
        this.hasRole('Accountant') ||
        this.hasRole('SuperAdmin') ||
        (this.hasRole('OrganizationAdmin') && !this.hasOnlyOrganizationAdminRole())
      )
    );
  }

  hasOnlyOrganizationAdminRole(): boolean {
    return this.roles.length === 1 && this.roles[0].role === 'OrganizationAdmin';
  }
  
  hasRole(targetRole: string): boolean {
    return this.isLoggedIn() && this.roles.some((role) => role.role === targetRole);
  }
  hasEmpRole(targetRole: string): boolean {
    return this.isLoggedIn() && this.roleEmp.some((role) => role.role === targetRole && role.status==="Blocked");
  }
  getUserNameFromLocal(): string {
    const storedResponse = localStorage.getItem('LoginResponse');
    if (storedResponse !== null) {
      const parsedResponse = JSON.parse(storedResponse);
      return parsedResponse._items[0].name;
    } else {
      console.error('Stored response is null');
      return '';
    }
  }
  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }

  getUserRole(): void {
    this.ds.getParticularUserRole(this.getUserIdFromLocal()).subscribe(
      (response: any) => {
        this.roles = response._items;
        this.roleEmp=response._items;
        console.debug("'''''",response._items);
      },
      (error) => {
        console.error('Error fetching Role:', error);
      }
    );
  }
}

